import React from 'react';
import axios from 'axios';
import { useState } from 'react';

const Delete = () => {

    const [name, setName] = useState("");
    const [age, setAge] = useState("");
    const [job, setJob] = useState("");
    const [add, setAdd] = useState("");
    const [id, setId] = useState();
    const [res, setRes] = useState();
    const clickHandler = () => {
        console.log("clicked on delete")
        axios.put(`https://6305c64a697408f7edcacd27.mockapi.io/user/${id}`, {
            name: `${name}`,
            age: `${age}`,
            job: `${job}`,
            address: `${add}`
        })
            .then((response) => {
                console.log(response.status)
                console.log("Data has been Updated");
                setRes("Data has been Updated")

            })
            .catch((error) => {
                console.log(error.message)
                setRes(error.message)
            })
    }
    return (
        <>
            <div className="wrap-1">
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <div className="getData">
                                <h1 className='white'>Please fill all input to Update Data then enter Unique Id...</h1>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-6 col-m-12">
                            <div className="update">
                                 <input type="text" value={name} onChange={(evt) => setName(evt.target.value)} placeholder="Enter Your Name" /> 
                            </div>
                        </div>
                        <div className="col-6 col-m-12">
                            <div className="update">
                            <input type="text" value={age} onChange={(evt) => setAge(evt.target.value)} placeholder="Enter Your Age" /> 
                            </div>
                        </div>
                        <div className="col-6 col-m-12">
                            <div className="update">
                            <input type="text" value={job} onChange={(evt) => setJob(evt.target.value)} placeholder="Enter Your Job" />
                            </div>
                        </div>
                        <div className="col-6 col-m-12">
                            <div className="update">
                            <input type="text" value={add} onChange={(evt) => setAdd(evt.target.value)} placeholder="Enter Your Address" />
                            </div>
                        </div>
                        <div className="col-6 col-m-12">
                            <div className="update">
                            <input type="text" name="uid" size="4" placeholder='Id No' value={id} onChange={(evt) => setId(evt.target.value)} />
                            </div>
                        </div>
                        <div className="col-6 col-m-12">
                            <div className="update">
                            <button onClick={clickHandler}>Update</button>
                            </div>
                        </div>
                    </div>
                    <hr />
                    <div className="row">
                        <div className="col-12">
                            <div className="success">
                                <h1>{res}</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Delete;